import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { WebcamImage } from 'ngx-webcam';
import { CameraComponent } from '../common/components/camera/camera.component';
import { LoaderService } from '../shared/services/common/loader/loader.service';
import { Selfie } from '../shared/models/selfie.model';
import { AppService } from '../shared/services/app/app.service';
import { LocalStoreService } from '../shared/services/common/local-store/local-store.service';
import { HttpClientModule } from '@angular/common/http';
import { Guid } from 'guid-typescript';
import { async } from 'rxjs/internal/scheduler/async';
//some change are done
declare var $: any;
declare var window: any;
let security_Longitude: any;
let security_Latitude: any;
// let security_City: any;
// let security_State: any;
// let security_Country: any;
let security_Redirect_Url: any;
// let security_Guid: any;
let security_IP: any;

@Component({
	selector: 'app-selfie',
	templateUrl: './selfie.component.html',
	styleUrls: ['./selfie.component.scss'],
})
export class SelfieComponent implements OnInit {
	public browserVersion: string;
	public browserName: string;
	public apiTime: number;
	showLoader: boolean = false;
	public guId: Guid;
	public isLoading: boolean = true;
	public webcamImage: string;

	public selfie: Selfie;
	public message: string;
	public Latitude: any;
	public Longitude: any;
	buttonReady = false;

	public success: boolean = false;

	public redirecting: boolean = false;

	@ViewChild('camera') camera: CameraComponent;

	public isLoggedIn: boolean = false;
	public isLocationCaptured: boolean = false;

	public constructor(
		private appService: AppService,
		private localStore: LocalStoreService,
		private route: ActivatedRoute,
		private router: Router
	) {
		this.guId = Guid.create();
	}

	public ngOnInit(): void {
		var me = this;
		// this.captureGeo()
		//Confirm token is received as query param
		this.route.queryParams.subscribe((params) => {
			params = me.toLowerParams(params);

			if (params['t']) {
				me.localStore.setDataOnLogin(params['t']);
				me.verifyAuth();
			} else {
				me.isLoggedIn = false;
				$('#wrd').modal('show');
			}
		});
		this.selfie = new Selfie();
		this.browserVersion = this.detectBrowserVersion();
		this.browserName = this.detectBrowserName();

		this.captureGeo();


	}
	async verifyAuth() {
		this.isLoggedIn = await this.appService.verifyAuth().toPromise();
		// this.checkButtonReady();
	}


	captureGeo() {
		let me = this;
		me.isLocationCaptured = false;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position: any) => {
					me.selfie.Latitude = position.coords.latitude;
					me.selfie.Longitude = position.coords.longitude;
					me.isLocationCaptured = true;
					security_Latitude = position.coords.latitude;
					security_Longitude = position.coords.longitude;
					this.isLoading = false;
					// if(!security_Redirect_Url)(
					// 	this.redirect_url_from_new_data()
					// )
					// this.sendlocation(afsf, gsjjh);

					$('#location-denied-modal').modal('hide');
					$('#location-phone').modal('hide');
				},
				() => {
					$('#location-denied-modal').modal('show');
					$('#location-phone').modal('show');
					// if(!security_Redirect_Url)(
					// 	this.redirect_url_from_new_data()
					// )
					// need to uncomment on production , this is added for Blisk testing.
					this.isLoading = false;
				},
				{
					enableHighAccuracy: false,
					timeout: 8000,
					maximumAge: 0
				}
			);
		} else {
			$('#location-denied-modal').modal('show');
			$('#location-phone').modal('show');
			// if(!security_Redirect_Url)(
			// 	this.redirect_url_from_new_data()
			// )
		}
	}

	// checkButtonReady(){
	// 	if ( this.isLoggedIn && this.isLocationCaptured){
	// 		this.buttonReady = true;
	// 	}
	// }

	capture() {
		this.isLoading = true;
		this.camera.toggleWebcam();
	}

	public getObjectFitSize = function (b, g, a, d, f) {
		var h = d / f
			, k = g / a;
		(b ? h > k : h < k) ? (b = g,
			k = b / h,
			d = f / k) : (k = a,
				b = k * h,
				d /= b);
		return {
			width: b,
			height: k,
			x: (b - g) * d / 2,
			y: (k - a) * d / 2,
			ratio: d
		}
	};
	async pictureTaken(image: WebcamImage, browserName: any, browserVersion: any,) {
		var me = this;
		// this.redirect_url_from_new_data()

		this.webcamImage = image.imageAsDataUrl;

		this.selfie.Image = image.imageAsBase64;
		this.selfie.BrowserName = browserName;
		this.selfie.BrowserVersion = browserVersion;

		const videoEl = <HTMLVideoElement>self.document.getElementById("webcam")
		var f = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
		const canvas = self.document.createElement("canvas");
		canvas.width = parseInt(f.style.width);
		canvas.height = parseInt(f.style.height);
		var h = canvas.getContext("2d");
		var k = parseInt(f.style.width),
			l = parseInt(f.style.height),
			m = this.getObjectFitSize(!1, k, l, f.videoWidth, f.videoHeight);
		// console.log(f.offsetHeight, f.offsetWidth)
		h.drawImage(f, m.x, m.y, k * m.ratio, l * m.ratio, 0, 0, k, l);


		this.appService.analyzeSelfie(this.selfie).subscribe(
			(response) => {
				const modifiedImage = canvas.toDataURL('image/png');
				me.webcamImage = modifiedImage;
				me.selfie.Image = modifiedImage;
				me.message = response.remark;
				me.success = response.is_valid == 1;
				me.camera.toggleWebcam();
				$('#success-modal-camera').modal('show');

				if (me.success) {
					// const modifiedImage = await	loadImageAndProcessImage(this.selfie.Image)

					// resolve(modifiedImage);

					window.setTimeout(function () {

						// if (!security_Redirect_Url) {
						// 	window.location.href = `${security_Redirect_Url}?city=${response.city}&country=${response.country}&state=${response.state}&Latitude=${security_Latitude}&Longitude=${security_Longitude}&uid=${response.Unique_Id}&IP=${security_IP}`;
						// } else {
						// 	window.setTimeout(function () {
						// 		window.location.href = `${security_Redirect_Url}?city=${response.city}&country=${response.country}&state=${response.state}&Latitude=${security_Latitude}&Longitude=${security_Longitude}&uid=${response.Unique_Id}&IP=${security_IP}`;
						// 	}, 2000);
						// }

						// console.log('response',response);
						
						parent.postMessage(response, '*');


					}, 3000);
				}
			},
			(error) => {
				this.camera.toggleWebcam();
			}
		);
	}
	retry() {
		$('#success-modal-camera').modal('hide');
		this.camera.toggleWebcam();
	}
	reload() {
		window.location.reload()
	}
	// clickagainonsuccess() {
	// 	$('#success-modal-camera').modal('hide');
	// }
	//  async redirect_url_from_new_data() {
	// 	let current_token;
	// 	this.route.queryParams.subscribe((params) => {
	// 		params = this.toLowerParams(params);
	// 		current_token = params.t
	// 	});
	// 	var settings = {
	// 		"url": `https://ndq336kxs6.execute-api.ap-south-1.amazonaws.com/default/kotak_web_faceliveliness_redirect_url?T=${current_token}`,
	// 		"method": "GET",
	// 		"timeout": 0,
	// 		"headers": {
	// 		  "x-api-key": "ddTJfJ21007E2uJ1OtXiZ8ZO7tS84F9p7NNdBMdn",
	// 		  "Content-Type": "application/json"
	// 		},
	// 		// "data": JSON.stringify({
	// 		//   "T":current_token
	// 		// }),
	// 	  };

	// 		await $.ajax(settings).done(function (response) {
	// 			// console.log(response)
	// 			security_Redirect_Url = response.Redirect_url;
	// 			security_IP = response.ip_address;


	// 	  });
	// }
	redirect() {
		$('#success-modal-camera').modal('hide');
		let me = this;
		if (me.redirecting) return;
		me.redirecting = true;
		me.appService.getRedirectUrl().subscribe(
			(response) => {
			},
			() => {
				me.redirecting = false;
			}
		);
	}

	toLowerParams(params: Params): Params {
		const lowerParams: Params = {};
		for (const key in params) {
			lowerParams[key.toLowerCase()] = params[key];
		}
		return lowerParams;
	}


	detectBrowserName() {
		this.selfie.BrowserName = this.browserName;
		let agent = window.navigator.userAgent.toLowerCase();
		switch (true) {
			case agent.indexOf('edga') > -1:
				return 'edge';
			case agent.indexOf('opr') > -1 && !!(<any>window).opr:
				return 'opera';
			case agent.indexOf("vivobrowser") > -1:
				return "vivobrowser";
			case agent.indexOf("samsungbrowser") > -1:
				return "samsungbrowser";
			case agent.indexOf("oppobrowser") > -1:
				return "oppobrowser";
			case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
				return 'chrome';
			case agent.indexOf('trident') > -1:
				return 'ie';
			case agent.indexOf('firefox') > -1:
				return 'firefox';
			case agent.indexOf('safari') > -1:
				return 'safari';
			default:
				return 'other';
		}
	}
	detectBrowserVersion() {
		this.selfie.BrowserVersion = this.browserVersion;
		var userAgent = navigator.userAgent,
			tem,
			matchTest =
				userAgent.match(
					/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
				) || [];

		if (/trident/i.test(matchTest[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
			return 'IE ' + (tem[1] || '');
		}
		if (matchTest[1] === 'Chrome') {
			tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
			if (tem != null)
				return tem.slice(1).join(' ').replace('OPR', 'Opera');
		}
		matchTest = matchTest[2]
			? [matchTest[1], matchTest[2]]
			: [navigator.appName, navigator.appVersion, '-?'];
		if ((tem = userAgent.match(/version\/(\d+)/i)) != null)
			matchTest.splice(1, 1, tem[1]);
		return matchTest.join(' ');
	}
}

